<template>
  <div class="article-item" @click="goDetail">
    <div class="img">
      <img :src="info.img" alt="">
    </div>
    <div class="content">
      <div class="type">
        {{info.type}}
      </div>
      <div class="title">
        {{info.title}}
      </div>
      <div class="desc">
        {{info.desc}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    goDetail () {
      if (this.info.link) {
        window.open(this.info.link, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.article-item {
  display: flex; justify-content: space-between; align-items: center;
  margin-bottom: 40px;
  width: 535px;
  height: 170px;

  @include isMobile {
    margin-bottom: 20px;
    width: 100%;
    height: 112px;
  }

  & .img {
    flex: none;
    position: relative;
    width: 130px;
    height: 170px;
    border-radius: 5px;
    overflow: hidden;
    @include isMobile {
      width: 85px;
      height: 112px;
    }

    & img {
      position: absolute; top: 50%; left: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: 100%;
    }
  }

  & .content {
    padding-left: 27px;
    @include isMobile {
      padding-left: 15px;
    }

    & .type {
      display: inline-block;
      padding: 5px 13px;
      margin-bottom: 10px;
      background-image: linear-gradient(to right, $blue, $green);
      border-radius: 0 0 4px 4px;
      box-shadow:0px 3px 10px 0px rgba(0,88,169,0.2);
      color: #FFF;
      @include lineFont(12, 400);

      @include isMobile {
        margin-bottom: 6px;
        padding: 4px 10px;
        @include lineFont(10, 500);
      }
    }

    & .title {
      margin-bottom: 7px;
      color: $black;
      line-height: 26px;
      @include font(18, 500);

      @include isMobile {
        margin-bottom: 4px;
        line-height: 18px;
        @include font(14, 500);
      }
    }

    & .desc {
      color: $lightGray;
      line-height: 20px;
      @include font(14, 400);
      @include row(3);

      @include isMobile {
        line-height: 16px;
        @include font(12, 400);
      }
    }
  }
}
</style>